import { Injectable, inject } from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthentificationService} from '../services/authentification.service';

@Injectable()
export class IsPresidentGuard  {
    private authService = inject(AuthentificationService);
    private router = inject(Router);


    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {
        // c'est le rôle de l'AuthGuard de vérifier que l'on est connecté
        if(!this.authService.isLogin){
            return true;
        }

        if (this.authService.isPresident() || this.authService.isAdmin()) {
            return true;
        } else {
            this.router.navigate(['/']);
        }
    }
}
